import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalComponents from './global-components'
import utils from './utils'
import './libs'
import { i18n } from './locale'

// SASS Theme
import './assets/sass/app.scss'
import OpenLayersMap from 'vue3-openlayers'
import 'vue3-openlayers/dist/vue3-openlayers.css'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(OpenLayersMap)
  .use(i18n)

globalComponents(app)
utils(app)

app.mount('#app')
